<template style="font-family: Times New Roman">
  <v-card v-if="checkaccessdata.is_viewer == false" class="mt-16" flat>
    <v-row justify="center" align="center">
      <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
    </v-row>
    <v-row justify="center" align="center">
      <v-card-subtitle class="subtitle-1"
        >You do not have Permission to access.</v-card-subtitle
      >
    </v-row>
  </v-card>
  <v-card class="ma-2" v-else>
    <v-row class="mt-0 ml-3">
      <v-row class="mt-1">
        <!-- <v-col cols="10"> -->
        <v-card-title class="primary--text"
          ><v-btn @click="back" class="ml-n7 primary--text" text>
            <v-icon>mdi-reply</v-icon></v-btn
          >Transactions
          <span
            style="
              font-style: italic;
              font-family: Times New Roman;
              font-size: 14px;
            "
            class="text-left font-weight: 20 primary--text ml-2"
            >(Transaction Details of Corporate)</span
          >
        </v-card-title>

        <!-- </v-col>
        <v-col lg="2" class="mt-6"> -->
        <v-spacer></v-spacer>
        <!-- <v-btn dark theme--light rounded class="elevation-0 mt-0 mr-12 mt-5 navbar">
            <v-icon left dark>mdi-upload</v-icon>EXPORT
          </v-btn> -->
        <!-- </v-col> -->
      </v-row>

      <v-card-text>
        <v-row class="mt-n3">
          <v-col cols="12" sm="12" xs="12" xl="2" md="2" lg="2">
            <v-dialog
              ref="dialogEnd"
              v-model="modalEnd"
              :return-value.sync="end_data"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  class="ml-n2 mx-2 mt-1"
                  v-model="end_data"
                  label="From"
                  append-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
                <!-- /*---*/ -->
              </template>
              <v-date-picker v-model="end_data" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalEnd = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialogEnd.save(end_data)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog></v-col
          >
          <v-col cols="12" sm="12" xs="12" xl="2" md="2" lg="2">
            <v-dialog
              ref="dialogEnd1"
              v-model="modalEnd1"
              :return-value.sync="enddata"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  outlined
                  color="primary"
                  dense
                  class="ml-n2 mx-2 mt-1"
                  v-model="enddata"
                  label="To"
                  append-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
                <!-- /*---*/ -->
              </template>
              <v-date-picker v-model="enddata" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalEnd1 = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialogEnd1.save(enddata)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog></v-col
          >

          <v-col cols="12" sm="12" xs="12" xl="2" md="2" lg="2">
            <v-select
              v-model="transectnStatus"
              dense
              style="width: 900px"
              class="ml-0 mx-0 lg-2 mt-1"
              item-text="name"
              item-value="value"
              :items="transectionList"
              label="Transaction Type"
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" xs="12" xl="1" md="1" lg="1" class="mt-1">
            <v-btn
              small
              @click="getFundDetails(end_data, enddata)"
              fab
              text
              color="dark"
              class="elevation-0"
            >
              <v-icon dark>mdi-filter</v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="12" xs="12" xl="3" md="3" lg="3">
            <v-text-field
              dense
              shaped
              outlined
              v-model="search"
              @keyup.enter="getFundDetails(end_data, enddata)"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-row>
    <v-row class="mt-n10">
      <v-col cols="12" sm="12" xs="12" xl="12" md="12" lg="12">
        <v-data-table
          :headers="headers"
          :items="transactions"
          dense
          :search="search"
          item-key="name"
          :no-data-text="Nodata"
        >
          <template v-slot:[`item.sl_no`]="{ item }">
            <span class="caption">{{ transactions.indexOf(item) + 1 }}</span>
          </template>
          <template v-slot:[`item.txn_type_value`]="{ item }">
            <span class="caption">{{ item.txn_type_value }}</span>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span class="caption red--text" v-if="item.type == 2"
              >- {{ item.amount }}</span
            >
            <span class="caption red--text" v-if="item.type == 3"
              >- {{ item.amount }}</span
            >
            <span class="caption green--text" v-if="item.type == 1"
              >+ {{ item.amount }}</span
            >
          </template>
          <template v-slot:[`item.created_on`]="{ item }">
            <span class="caption">{{ item.created_on }}</span>
          </template>
          <template v-slot:[`item.account_balance`]="{ item }">
            <span class="caption">{{ item.account_balance }}</span>
          </template>
          <template v-slot:[`item.user_name`]="{ item }">
            <span class="caption"
              ><b>{{ item.user_name }}</b></span
            ><br />

            <span class="caption" v-if="item.mobile_no != null">{{
              item.mobile_no
            }}</span>
            <span class="caption" v-else>-</span>
          </template>
          <template v-slot:[`item.View`]="{ item }">
            <span>
              <v-icon
                small
                class="ml-2"
                @click="showContent(item)"
                v-on="on"
                color="primary"
                >mdi-eye</v-icon
              ></span
            >
          </template>
        </v-data-table>
        <v-dialog v-model="contentDialog" max-width="400">
          <v-card>
            <v-toolbar flat class="header" dense dark>
              <v-icon>mdi-format-list-bulleted-type</v-icon>
              <span class="ml-3"> Transaction Details</span>
              <v-spacer></v-spacer>
              <v-btn class text dark @click="contentDialog = false">
                <v-icon color="white" small>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text class="mt-1">
              <v-card elevation="1" shaped class="mt-5 ml-5 mr-5 mb-5">
                <v-row>
                  <v-col cols="12" md="12" lg="12">
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Amount</b>
                        </span>
                        <br />
                        <span
                          class="caption red--text"
                          v-if="contentDetails.type_value == 'Debit'"
                          >- {{ contentDetails.amount }}
                          <span class="caption black--text">MYR</span>
                        </span>
                        <span
                          class="caption green--text"
                          v-if="contentDetails.type_value == 'Credit'"
                          >+ {{ contentDetails.amount }}
                          <span class="caption black--text">MYR</span>
                        </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Account Balance</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="contentDetails.account_balance != null"
                        >
                          {{ contentDetails.account_balance }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                    <v-row class="ml-3">
                      <v-col cols="12" md="12" lg="12">
                        <span class="subtitle-2">
                          <b class="primary--text">Created On</b>
                        </span>
                        <br />
                        <span
                          class="caption"
                          v-if="contentDetails.created_on != null"
                        >
                          {{ contentDetails.created_on }}
                        </span>
                        <span class="caption ml-2" v-else> - </span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <OverleyProccessg :overlay="overlay" />
  </v-card>
</template>

<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";

import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  components: {
    OverleyProccessg,
  },
  data: () => ({
    checkaccessdata: {},
    search: "",
    contentDialog: false,
    overlay: false,
    on: "",
    headers: [
      { text: "SL NO", value: "sl_no", width: "50px" },

      {
        text: "TRANSACTION TYPE",
        value: "txn_type_value",
        width: "50px",
      },
      {
        text: "USER DETAILS",
        value: "user_name",
        align: "start",
        width: "50px",
        sortable: false,
      },
      {
        text: "TRANSACTED ON",
        value: "created_on",
        width: "50px",
      },
      {
        text: " AMOUNT(MYR)",
        value: "amount",
        width: "50px",
      },
      {
        text: " CLOSING BALANCE(MYR)",
        value: "account_balance",
        width: "50px",
      },
      // {
      //   text: " TXN MSG",
      //   value: "",
      //   width: "50px",
      // },
      // {
      //   text: " STATUS",
      //   value: "",
      //   width: "50px",
      // },
      {
        text: "VIEW",
        value: "View",
        width: "50px",
      },
    ],
    transectnStatus: 0,
    transectionList: [
      {
        name: "All",
        value: 0,
      },
      {
        name: "Card Pack Fee",
        value: 1,
      },
      {
        name: "Monthly Subscription Fee",
        value: 2,
      },
      {
        name: "Renewal Subscription Fee",
        value: 3,
      },
      {
        name: "Funding - Bank Transfer",
        value: 4,
      },
      {
        name: "Funding - Cheque Deposit",
        value: 5,
      },
      {
        name: "Funding - FPX",
        value: 6,
      },
      // {
      //   name: "Funding - JomPay",
      //   value: 7,
      // },
      {
        name: "Funding - Card",
        value: 8,
      },
      // {
      //   name: "Debit Adjustment",
      //   value: 9,
      // },
      {
        name: "Refund to Bank",
        value: 10,
      },
      {
        name: "Load Card",
        value: 11,
      },
      {
        name: "Unload Card",
        value: 12,
      },
    ],
    contentDetails: {},
    modalEnd1: false,
    expanded: [],
    type: [],
    modalEnd: false,
    enddata: new Date().toISOString().substr(0, 10),
    end_data: new Date().toISOString().substr(0, 10),
    Transactionstatus: ["Approved", "Pending", "Rejected"],
    transactions: [],
    Nodata: "",
  }),
  created() {
    this.end_data = new Date(
      (Math.floor(new Date().getTime() / 1000.0) - 2629743) * 1000
    )
      .toISOString()
      .substr(0, 10);
    this.checkaccess();
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "CFUNDS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getFundDetails(this.end_data, this.enddata);
      }
    },
    back() {
      this.$router.push("/Dashboard");
    },
    showContent(item) {
      this.contentDialog = true;
      this.contentDetails = item;
      // console.log(" this.contentDetails", this.contentDetails);
    },
    async getFundDetails(start, end) {
      var inputData = {
        method_name: "CFUND",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "TRANSACTIONS",
          corp_id: this.$store.getters.get_corpid,
          search_text: this.search,
          from_date: start,
          to_date: end,
          request_type: this.transectnStatus,
        },
      };

      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.transactions = responseData.data.data;
        }
        // console.log(this.transactions);

        this.overlay = false;
      } else if (responseData.data.status == "NOREC") {
        (this.Nodata = responseData.data.status_msg), (this.transactions = []);
        this.overlay = false;
      }
    },
  },
};
</script>

<style>
.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
</style>
